import { type BrowserOptions, SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN } from '@sentry/react';

type TracesSampler = NonNullable<BrowserOptions['tracesSampler']>;

const sampleRateByOrigin: Partial<Record<string, number>> = {
  'auto.pageload.browser': 0.25,
  'auto.navigation.browser': 0.1,
};

const defaultSampleRate = 0.1;

/**
 * Builds the Sentry `tracesSampler`: every transaction in `dev`, otherwise a per-origin rate
 * (pageload 0.25, navigation 0.1, anything else 0.1).
 */
export const createTracesSampler =
  (env: string): TracesSampler =>
  ({ attributes }) => {
    if (env === 'dev') {
      return 1;
    }

    const origin = attributes?.[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];

    return (typeof origin === 'string' ? sampleRateByOrigin[origin] : undefined) ?? defaultSampleRate;
  };
